import { render, staticRenderFns } from "./MenuCreate.vue?vue&type=template&id=f3cb1d86&"
import script from "./MenuCreate.vue?vue&type=script&lang=js&"
export * from "./MenuCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports